import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge } from "react-bootstrap";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import rice from '../../../../images/raw_material/rice.png';
import dhalimage from '../../../../images/raw_material/dhal.png';
import tomatoimage from '../../../../images/raw_material/tomato.png';
import Consumption from '../../../modal/Purchase_Management/Manage_Stocks/Consumption';
import ConsumptionHistory from '../../../modal/Purchase_Management/Manage_Stocks/Consumption_His';
import ConsumptionReturn from '../../../modal/Purchase_Management/Manage_Stocks/ConsumptionReturn';
import ResolveReason from '../../../modal/Purchase_Management/Manage_Stocks/StockchecklistReason';
import ViewVessel from '../../../modal/Purchase_Management/Manage_Stocks/ViewVessel';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import {  Col, Tab, Nav } from "react-bootstrap";
import Select from 'react-select';
import DatePicker from "react-multi-date-picker";
import dayjs from 'dayjs';
import View from '../../../modal/Purchase_Management/Manage_Stocks/ViewStock';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

const Stock = () => {
    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    
    const [open, setOpen] = useState(false); // Modal visibility state
    const [modalType, setModalType] = useState("");
    const [key, setKey] = useState('manage_vessel');
    const [hide,setHide]=useState('d-block');

    const handleModalToggle_History = () => {
        setModalType("ConsumptionHistory");  // Set the modal type to "Add"
        setOpen(true);
    };

    const handleModalToggle = () => {
        setModalType("View");
        setOpen(true);
    };
    const handleModalToggle_View = () => {
        setModalType("View-Vessel");
        setOpen(true);
    };

    const allTableData = [
            {
                consumptionDate: "30-Jul-2025",
                name: "Basmathi Rice",
                category: "Grains",
                brand: "Tata Sampann",
                expiryDays: 120,
                consumptionQty: 5,
                currentStock: 10,
                buyDate: "2025-07-24",
                buyQty: 15,
                stockLevel: "Available",
                stockLevelBadge: "warning",
                image: rice,
            },
            {
                consumptionDate: "28-Jul-2025",
                name: "Tomato",
                category: "Vegetable",
                brand: null,
                expiryDays: 1,
                consumptionQty: 3,
                currentStock: 2,
                buyDate: "2025-07-24",
                buyQty: 5,
                stockLevel: "Low",
                stockLevelBadge: "danger",
                image: tomatoimage,
            },
            {
                consumptionDate: "25-Jul-2025",
                name: "Dhal",
                category: "Pulses",
                brand: "Bharat Dal",
                expiryDays: 100,
                consumptionQty: 5,
                currentStock: 25,
                buyDate: "2025-07-20",
                buyQty: 30,
                stockLevel: "High",
                stockLevelBadge: "success",
                image: dhalimage,
            },
        ];


        const getFilteredTableData = () => {
    const today = dayjs();
    const yesterday = today.subtract(1, 'day');

    switch (date_fil_selt_value) 
        {
            case "today":
            return allTableData.filter(item =>
                dayjs(item.consumptionDate).isSame(yesterday, 'day')
            );

            case "this_week":
            return allTableData.filter(item =>
                dayjs(item.consumptionDate).isBetween(week_stdt_fil_value, week_eddt_fil_value, 'day', '[]')
            );

            case "this_month":
            return allTableData.filter(item =>
                dayjs(item.consumptionDate).isSame(month_fil_value, 'month')
            );

            case "custom":
            return allTableData.filter(item =>
                dayjs(item.consumptionDate).isBetween(custom_stdt_fil_value, custom_eddt_fil_value, 'day', '[]')
            );

            case "all":
            default:
            return allTableData;
        }
    };


    // const tableRef = useRef(null);

    const DeleteModal = () => {
        swal.fire({
            html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Stock
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>Basmathi Rice</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        })
    };



    useEffect(() => {
        const tables = document.querySelectorAll('.product_data_table');
        tables.forEach((table) => {
            if (!$.fn.dataTable.isDataTable(table)) {
                $(table).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        });
    }, []);

    const date_fil_options = [
        { value: "all", label: "All" },
        { value: "today", label: "Today" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custum Date" }
    ];

    const date_fil_options_stock = [
        { value: "all", label: "All" },
        { value: "yesterday", label: "Yesterday" },
        { value: "this_week", label: "This week" },
        { value: "this_month", label: "This Month" },
        { value: "custom", label: "Custum Date" }
    ];

    const [date_fil_selt_value, setDateFilSeltValue] = useState("all");
    const [week_stdt_fil_value, setWeekSTDTFilValue] = useState(new Date());
    const [week_eddt_fil_value, setWeekEDDTFilValue] = useState(new Date());
    const [month_fil_value, setMonthFilValue] = useState(new Date());
    const [custom_stdt_fil_value, setCustomSTDTFilValue] = useState(new Date());
    const [custom_eddt_fil_value, setCustomEDDTFilValue] = useState(new Date());
    const [yest_fil_value, setYestFilValue] = useState(dayjs().subtract(1, 'day').toDate());
    const [today_fil_value, setTodayFilValue] = useState(new Date());

    
    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Manage Stocks</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Purchase Management</li>
                    </ol>
                </div>
                
                {open && modalType === "Consumption" && (
                    <Consumption show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "ConsumptionHistory" && (
                    <ConsumptionHistory show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "Consumption_return" && (
                    <ConsumptionReturn show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "resolve_reason" && (
                    <ResolveReason show={open} onClose={() => setOpen(false)} />
                )}

                {open && modalType === "View" && (
                    <View show={open} onClose={() => setOpen(false)} />
                )}
                {open && modalType === "View-Vessel" && (
                    <ViewVessel show={open} onClose={() => setOpen(false)} />
                )}
            </div>

            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/manage-stocks" >
                                    <i className="fa-regular fa-user me-2" />
                                    <label className="ms-2 fs-6">
                                        Manage Stock
                                    </label>

                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link as={Link} to="/manage-stocks-checklist-history" >
                                    <i className="fa-solid fa-list-check me-2" />
                                    <label className="ms-2 fs-6">
                                        Stock Checklist History
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="manage_vessel">
                                    <i className="fa-solid fa-kitchen-set me-2" /> 
                                    <label className="ms-2 fs-6">
                                        Manage Vessel Stock
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li">
                                <Nav.Link as={Link} to="/manage-stocks-consumption" >
                                    <i className="fa-solid fa-cookie-bite me-2" /> 
                                    <label className="ms-2 fs-6">
                                        Stock Consumption
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                         
                        <Tab.Content className="pt-4">
                        
                            <Tab.Pane eventKey="manage_vessel">
                                <div className='row'>
                                    <div className='col-lg-12'>
                                        <Link to='/vessel-checklist' className="btn btn-primary float-end btn-sm">
                                            <span className='me-2'><i class="fa-solid fa-list-check  fs-8"></i></span>
                                            <span className=''>Stock Checklist</span>
                                        </Link>
                                    </div>
                                </div>
                                <div className='row mb-4'>
                                    <div className="col-lg-3 mb-2">
                                        <label className="text-black font-w500 fs-7">Date</label>
                                        <Select
                                            value={date_fil_options_stock.find(option => option.value === date_fil_selt_value)}
                                            onChange={(selectedOption) => setDateFilSeltValue(selectedOption.value)}
                                            options={date_fil_options_stock}
                
                                        />
                                    </div>
                                   
                                    {date_fil_selt_value === "all" && <></>}
                                    {date_fil_selt_value === "yesterday" && (
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">Yesterday</label>
                                            <div className='datepicker-wrapper d-flex'>
                                                <div className='input-group-text bg-transparent border-0 px-0'>
                                                    <i className='fa-solid fa-calendar-days fs-4'></i>
                                                </div>
                                                <DatePicker
                                                    value={yest_fil_value}
                                                    onChange={setYestFilValue}
                                                    format="DD-MM-YYYY"
                                                    readOnly={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {date_fil_selt_value === "this_week"  && (
                                        <>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">Start Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={week_stdt_fil_value}
                                                        onChange={setWeekSTDTFilValue}
                                                        format="DD-MM-YYYY"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">End Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={week_eddt_fil_value}
                                                        onChange={setWeekEDDTFilValue}
                                                        format="DD-MM-YYYY"
                                                        calendarPosition="top-end"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                    {date_fil_selt_value === "this_month" && (
                                        <div className="col-lg-3 mb-2">
                                            <label className="text-black font-w500 fs-7">This Month</label>
                                            <div className='datepicker-wrapper d-flex'>
                                                <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                <DatePicker
                                                    value={month_fil_value}
                                                    onChange={setMonthFilValue}
                                                    format="MMM-YYYY"
                                                    calendarPosition="top"
                                                    mode="single"
                                                    onlyMonthPicker={true}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {date_fil_selt_value === "custom" && (
                                        <>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">Start Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={custom_stdt_fil_value}
                                                        onChange={setCustomSTDTFilValue}
                                                        format="DD-MM-YYYY"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 mb-2">
                                                <label className="text-black font-w500 fs-7">End Date</label>
                                                <div className='datepicker-wrapper d-flex'>
                                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                                    <DatePicker
                                                        value={custom_eddt_fil_value}
                                                        onChange={setCustomEDDTFilValue}
                                                        format="DD-MM-YYYY"
                                                        calendarPosition="top-end"
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                
                                <div className="table-container">
                                    <table className="product_data_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2">
                                        <thead>
                                            <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                <th className='min-w-100px'>Cookware</th>
                                                <th className='min-w-100px'>Material / Count</th>
                                                <th className='min-w-100px text-center'>Current Stock</th>
                                                {/* <th className='min-w-100px text-center'>Stock Level</th> */}
                                                <th className='min-w-100px text-center'>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold fs-7">
                                            <tr>
                                                <td>
                                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                                        
                                                        <div>
                                                            <label className='text-black font-w500 fs-6'>12-inch Karandi</label>
                                                            <div className="d-block">
                                                                <label className="fs-7 text-primary font-w400">Utensils</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td align='start'>
                                                    {/* <Badge bg="info" className='fw-semibold fs-7 text-white'>Tata Sampann</Badge> */}
                                                    <div className='text-black font-w500 fs-6'>Aluminium</div>
                                                    <div className='d-block mt-1'>
                                                        <label className='text-primary font-w400 fs-7'>24</label>
                                                    </div>
                                                </td>
                                              
                                                <td align='center'>
                                                    
                                                    <div className='d-block mt-1'>
                                                        <Badge bg="primary" className='fw-semibold fs-7 text-white border border-primary'>
                                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' >Available</Tooltip>} >
                                                           <span>10</span>
                                                        </OverlayTrigger>
                                                        </Badge>
                                                            <span className='mx-1'> / </span>
                                                        <Badge bg="primary" className='fw-semibold fs-7 text-white border border-primary'>
                                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' >Comsumed</Tooltip>} >
                                                             <span>14</span>
                                                        </OverlayTrigger>
                                                        </Badge>
                                                            
                                                        
                                                    </div>
                                                    
                                                </td>
                                                {/* <td align='center'>
                                                    <Badge bg="warning" className='text-white fs-7 py-0 px-1'>Available</Badge>
                                                </td> */}
                                                <td align='center'>
                                                    <span class="text-end">
                                                        <OverlayTrigger trigger="hover" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Consumption History</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={handleModalToggle_View}>
                                                                <span><i class="fa-solid fa-clock-rotate-left fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        
                                                    </span>
                                                </td>
                                            </tr>
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </Tab.Pane>

                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    )


}
export default Stock;